/** Mini-map góc màn hình (M3): vị trí hiện tại + giờ mở cửa các khu. */
import { khuDaMo, khuMoTheoGio } from '../../core/khu-vuc.js';
import { gioTrongNgay } from '../../core/khach.js';
import type { GameController } from '../game-controller.js';
import { useCapNhat } from '../dung-chung.js';

export function MiniMap(props: { controller: GameController; moBanDo: () => void }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const gio = gioTrongNgay(state.tongGioGame);
  const ds = khuDaMo(state, duLieu);
  const ten = ds.find((k) => k.ma === state.khuHienTai)?.ten ?? state.khuHienTai;

  return (
    <button
      onClick={props.moBanDo}
      style={{
        position: 'fixed',
        top: '64px',
        right: '8px',
        zIndex: 40,
        background: 'rgba(20, 14, 8, 0.85)',
        color: '#f5e9d0',
        border: '1px solid #8a6a3a',
        borderRadius: '8px',
        padding: '6px 10px',
        fontSize: '13px',
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <div style={{ fontWeight: 700 }}>📍 {ten}</div>
      <div style={{ fontSize: '11px', opacity: 0.8 }}>
        {gio}h
        {ds
          .filter((k) => k.ma !== state.khuHienTai)
          .map((k) => (khuMoTheoGio(k, gio) ? ` · ${k.ten} mở` : ` · ${k.ten} đóng`))
          .join('')}
      </div>
    </button>
  );
}
